import React from "react";
import {
  Row,
  Col,
  Card,
  CardTitle,
  Button,
  ListGroup,
  ListGroupItem,
} from "reactstrap";
import PropTypes from "prop-types";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faMapPin, faTrash } from "@fortawesome/free-solid-svg-icons";

import "./SeshCard.scss";
import { Rating } from "@bit/primefaces.primereact.rating";
import PrimereactStyle from "@bit/primefaces.primereact.internal.stylelinks";
import { capitalize, degToCompass } from "../util/view";
import { Link } from "react-router-dom";

const SeshCard = ({ sesh, pageNumber, editSesh, handleDelete }) => {
  return (
    <Card className="feed-card mx-auto">
      <CardTitle className="seshcard-title">
        <Row>
          <Col xs="auto" className="ml-auto">
            <h4>
              {moment
                .utc(sesh.startTime, moment.ISO_8601)
                .format("ddd, MMMM Do h:mm a")}
            </h4>
          </Col>
          <Col xs="auto" className="ml-5">
            <Button
              className="edit-button"
              color="link"
              onClick={() => editSesh(sesh.id, pageNumber)}
            >
              <FontAwesomeIcon icon={faPen} />
            </Button>
          </Col>
          <Col xs="auto" className="mr-1">
            <Button
              className="edit-button"
              color="link"
              onClick={() => handleDelete(sesh.id, pageNumber)}
            >
              <FontAwesomeIcon icon={faTrash} />
            </Button>
          </Col>
        </Row>
      </CardTitle>
      <Row className="px-1 justify-content-center">
        <Col xs="auto" className="pr-0">
          <PrimereactStyle />
          <Rating
            className="star-rating-card"
            id="rating"
            readonly
            cancel={false}
            value={sesh.rating}
          />
        </Col>
        <Col xs="auto">
          <FontAwesomeIcon
            icon={faMapPin}
            style={{ verticalAlign: "baseline" }}
          />
          <h4
            style={{ display: "inline-block", marginLeft: 5, color: "black" }}
          >
            <Link to={`spot/${sesh.spot.id}`}>
              {capitalize(sesh.spot.name)}
            </Link>
          </h4>
        </Col>
      </Row>
      <Row noGutters className="desc-row">
        <Col xs={12} className="align-self-center">
          <div className="description-container">{sesh?.description}</div>
        </Col>
      </Row>
      <Row className="swells-row">
        <Col xs={6}>
          <ListGroup className="pt-2 text-center">
            {sesh.swells.map((swell) => (
              <ListGroupItem className="swell-item" key={swell.id}>
                {swell.height}ft at {swell.period}s{" "}
                {degToCompass(swell.direction)} {swell.direction}º
              </ListGroupItem>
            ))}
          </ListGroup>
        </Col>
        <Col xs={6}>
          <ListGroup className="pt-2 text-center">
            {sesh.tides.map((tide) => (
              <ListGroupItem className="swell-item" key={tide.id}>
                {tide.height}ft {tide.rising ? "rising" : "falling"}
              </ListGroupItem>
            ))}
          </ListGroup>
        </Col>
      </Row>
    </Card>
  );
};

SeshCard.propTypes = {
  sesh: PropTypes.shape({
    startTime: PropTypes.string.isRequired,
    endTime: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    rating: PropTypes.number.isRequired,
    createdAt: PropTypes.string.isRequired,
    updatedAt: PropTypes.string.isRequired,
    spot: PropTypes.shape({
      name: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    }),
    user: PropTypes.shape({
      name: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
    }),
  }),
};

export default SeshCard;
